import React, { useState, useEffect, useRef } from "react";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../config/routeConfig";
import { TopBar } from "../../shared/topBar/TopBar";
import { useNavigate, useParams, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { SBADropDown, SBAComboBox } from "../../UiComponents/SBADropDown";
import { getPortFolioListAction } from "../../actions/portfolioAction";
import { getAssestListddlAction } from '../../actions/assetsddlAction';
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import moment from "moment";
import { getAsset, getAssetCurrencyType } from "../../actions/assetAction";
import { sbaAxios } from "../../utils/sbaAxios";
import { getAssetListByTermApi, inserUpdateCommitment, insertUpdateTransaction, insertUpdateTransactionAPI, getTransactionAssetsByType } from "../../../config/apiConfig";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer } from "react-toastify";
import { getTransactionStatusAction, getAssetsByType } from "../../actions/transactionAction";
import { getPortFolioDetailAction } from "../../actions/portfolioAction";
import { getPortfolioListAPI } from "../../../config/apiConfig";
import { getPortfolioExistingAsset } from "../../../config/apiConfig";
import { getPortfolioDetailAPI } from "../../../config/apiConfig";
import { getTransactionByID,getPortfolioListByAssetAndTransType,currencyFormatter,gettransactionEditAccess } from "../utils";
import { assetDetailsUrl } from "../../../config/apiConfig";
import { SBACurrencyInput } from "../../UiComponents/SBACurrencyInput";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ExchangeRateModal } from "../Components/ExchangeRateModal";
export const Commitment = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const history = useNavigate();
  const objType = parseInt(params?.ObjectType);


  // Getting Transaction ID From Previous page if Not Assigning the value as 0;  
  const transactionId = parseInt(params?.TransId) || 0;
  const Gstate = useSelector(state => state);
  const statusStore = Gstate.transaction.statusList || [];
  const [transactionData, setTransactionData] = useState(plainCommitment);
  const [assetList, setAssetList] = useState([]);
  const [portfolioList, setPortfolioList] = useState([]);
  const [statusDS, setStatusDS] = useState(statusStore);
  const [portfolio, setPortfolio] = useState();
  const [showModal, setShowModal] = useState(false);
  const[transactionEditAccess,setTransactionEditAccess]=useState(false);
  const statusVal = { "TransStatus": transactionData.TradeStatusName, "TransStatusId": transactionData.TradeStatusId };
  const portfolioVal = { "PortfolioId": transactionData.PortfolioId, "PortfolioName": transactionData.PortfolioName }
  const AssetVal = { "AssetId": transactionData.AssetId, "AssetName": transactionData.AssetName }
  useEffect(() => {
    document.title = "Transactions Commitment";
    setTransactionEditUserAccess();
    setTransactionByID(transactionId);
    if (objType == 1) {
      setAssetByID(params?.EntityId);
      setPortfolioByAssetId(params?.EntityId);
    }
    else if (objType == 3) {
      setPortfolioByID(params?.EntityId);
    }
    setAssetByTerm(null);
    dispatch(getTransactionStatusAction());

  }, []);


  useEffect(() => {
    setStatusDS(statusStore)
  }, [statusStore]);

 // User Access Rights
 const setTransactionEditUserAccess= async()=>
 {
     const access = await gettransactionEditAccess();
     setTransactionEditAccess(access);
 }

  const setAssetByID = async (Id) => {
    try {
      const asset = await getAssetByID(Id);
      setTransactionData(value => ({ ...value, AssetName: asset?.AssetName, AssetId: asset?.AssetId }));
    }
    catch (e) {
      setTransactionData(value => ({ ...value, AssetId: 0, AssetName: '' }));
      setPortfolio({});
    }
  }


  const setPortfolioByID = async (Id) => {
    try {
      const portfolio = await getPortfolioDetailsByID(Id);
      setTransactionData(value => ({ ...value, PortfolioId: portfolio?.PortfolioId, PortfolioName: portfolio?.PortfolioName }));
      setPortfolio(portfolio);
    }
    catch (e) {
      setTransactionData(value => ({ ...value, PortfolioId: 0, PortfolioName: '' }));
      setPortfolio({});
    }

  };

  const setPortfolioByAssetId = async (Id) => {
      
    try {
      const portfolio = await getPortfolioListByAssetAndTransType(Id,23);
    const  portfolios= portfolio.map((item) => ({
        'PortfolioName':item.Name,
        'PortfolioId':item.PortfolioId
    }))
      setPortfolioList([]);
      if(portfolios.length>0){
      setTransactionData(value => ({ ...value, "PortfolioName": portfolios[0]?.PortfolioName, "PortfolioId": portfolios[0]?.PortfolioId }));
  setPortfolioByID(portfolios[0]?.PortfolioId);
      }
    }
  
    catch (e) {
      setTransactionData(value => ({ ...value, PortfolioId: 0, PortfolioName: '' }));
      setPortfolioList({});
    }
  }
  const setPortfolioByTerm = async (term) => {
    try {
      const portfolioList = await getPortfolioListByTerms(term);
      setPortfolioList(portfolioList);
    }
    catch (e) {
      console.log(e, 'Error Fetching the data for portfolio');
      setPortfolioList([]);
    }
  };


  const setAssetByTerm = async (term) => {
    try {
      const assetList = await sbaAxios({ url: `${getTransactionAssetsByType}?transTypeId=${23}&searchString=${term}` });
      setAssetList(assetList);
    } catch (e) {
      console.log(e, 'Error Fetching the data for Asset');
      setAssetList([]);
    }
  };
  const setTransactionByID = async (id) => {
    if (id > 0) {
      try {
        const details = await getTransactionByID(id);
        setTransactionData(details);
        setPortfolioByID(details.PortfolioId);
      } catch (e) {
        setTransactionData(plainCommitment);
      }
    }
    else {
      setTransactionData(plainCommitment);
    }

  };
 
  const udpateTransAmmount = (e) => {
    const values = parseFloat(e);
    setTransactionData(value => ({ ...value, TransAmount: values }))
  }
  const Level = params.ObjectType == 1 ? [
    {
      BreadCrumb: "Transactions >",
      Routes: `${UrlPath.Transactions}${params.EntityId}`,
    },
    {
      BreadCrumb: "Commitment",
      Routes: `${UrlPath.Commitment}${params.EntityId}`,
    },
  ] : [
    {
      BreadCrumb: "Transactions >",
      Routes: `/${UrlPath.portfolioTransaction}${params.EntityId}`,
    },
    {
      BreadCrumb: "Commitment",
      Routes: `/${UrlPath.portfolioTransactionCommitment}${params.EntityId}/${params.ObjectType}`,
    },
  ];

  const saveCommitment = () => {
    const DS = {
      "transId": transactionId,
      "portfolioId": transactionData?.PortfolioId,
      "assetId": transactionData?.AssetId,
      "shareClassId": null,
      "assetLotId": 0,
      "tradeStatusId": transactionData.TradeStatusId,
      "transTypeId": 23,
      "transDate": transactionData?.TransDate,
      "transAmount": transactionData?.TransAmount,
      "localAmount": parseFloat((transactionData?.TransAmount * transactionData?.ExchangeRate).toFixed(2)) || 0,
      "exchangeRateId": 0,
      "exchangeRate": transactionData?.ExchangeRate,
      "allocationDate": null,
      "shares": 0,
      "nav": 0,
      "transDescription": transactionData?.TransDescription,
      "isFullRedemption": false,
      "isInsurance": false,
      "isFee": false,
      "isCommitmentRelease": transactionData?.IsCommitmentRelease,
      "modifiedBy": 0,
      "childTrans": []
    };

    if (DS?.assetId && DS.portfolioId && DS.transAmount && DS.transDate && DS.tradeStatusId >= 0 && DS.exchangeRate && Math.abs(DS.localAmount) > 0) {
      sbaAxios({ url: insertUpdateTransactionAPI, method: 'post', data: DS }).then((res) => {
        setTimeout(() => {
          transactionId !== 0 ? SBNotify({ Msg: 'Commitment Details Updated Successfully' }) : SBNotify({ Msg: 'Commitment Details Added Successfully' });
        }, 500);
        navigateBack();
      }).catch(e => {
        console.log(e);
      })
    }
    else {
      SBNotify({ Msg: 'Please Enter All the Required Fields', type: 'error' });
    }

  };
  const portfolioDDChng = (e) => {
    if (e.value) {
      setPortfolioByID(e.value.PortfolioId);

      if (objType === 3) {
        history(`/${UrlPath.portfolioTransactionCommitment}${transactionId}/${e.value.PortfolioId}/3`);
        setTransactionData(value => ({ ...value, AssetId: 0, AssetName: '' }));
      }

    }
  };
  const assetDDChng = (e) => {
    if (e.value) {
      setTransactionData(value => ({ ...value, AssetName: e.value.AssetName, AssetId: e.value.AssetId }));
      if (objType === 1) {
        setPortfolioByAssetId(e.value.AssetId);
        setAssetByID(e.value.AssetId);
        history(`${UrlPath.Commitment}${transactionId}/${e.value.AssetId}/1`);
      }
    }
  };
  const statusDDChng = (e) => {
    if (e.value) {
      setTransactionData(value => ({ ...value, TradeStatusId: e.value.TransStatusId, TradeStatusName: e.value.TransStatus }));
    }
  };
  const udpateDate = (e) => {
    if (e) {
      setTransactionData(value => ({ ...value, TransDate: e.toISOString() }))
    }
  };
  const navigateBack = () => {
    if (objType === 1)
      history(`${UrlPath.Transactions}${transactionData.AssetId}`);
    if (objType === 3)
      history(`/${UrlPath.portfolioTransaction}${transactionData.PortfolioId}`);
  };
  const portfolioFilterChange = (e) => {
    const terms = e.filter.value;
    if (terms.length > 1) {
      setPortfolioByTerm(terms);
    }
  };

  const assetFilterChange = (e) => {
    const terms = e.filter.value;
    if (terms.length > 1) {
      getAssetsByType(23, terms);
      setAssetByTerm(terms);
    }
  };

const handleClick = () => {
  setShowModal(true);
 
};

const exchangeRateChange=(e)=>
{
    const parsedValue = parseFloat(e);
    setTransactionData(value => ({
        ...value,
        ExchangeRate: parsedValue,
        LocalAmount: transactionData?.TransAmount * parsedValue,
    }));
}
  return (
    <>
      <TopBar label={"Transactions"} />
      <div id="TransactionList" className="mainContentData">
        <BreadCrumbs Levels={Level} />
        <div className="container-fluid p-3">
          <div className="detail p-4">

            <div className="row">
              <div className="row mb-4">
                <div className="col-md-4">
                  <label className="mb-1 label">Status<span className="mandatory">*</span></label>
                  <div>
                    <SBADropDown
                      className="w-75"
                      data={statusDS}
                      textField={"TransStatus"}
                      valueField={"TransStatusId"}
                      value={statusVal}
                      onChange={statusDDChng}
                    />
                  </div>
                </div>

                <div className="col-md-4">
              
                  <label className="mb-1 label">Portfolio<span className="mandatory">*</span></label>
                  <div>
                    <SBAComboBox
                      className="w-75"
                      data={portfolioList}
                      textField={"PortfolioName"}
                      valueField={"PortfolioId"}
                      value={portfolioVal}
                      onChange={portfolioDDChng}
                      onFilterChange={portfolioFilterChange}
                      disabled={transactionId !== 0}
                    />
                  </div>
                </div>
                </div>
             
              
              <div className="row mb-4">
                <div className="col-md-4">
                  <label className="mb-1 label">Asset<span class="mandatory">*</span></label>
                  <div>
                    <SBAComboBox
                      className="w-75"
                      data={assetList}
                      value={AssetVal}
                      textField={"AssetName"}
                      valueField={"AssetId"}
                      onChange={assetDDChng}
                      onFilterChange={assetFilterChange}
                      disabled={transactionId !== 0 }
                    />
                  </div>
                </div>
                </div>
                <div className="row mb-4">
                <div className="col-md-4">
                  <div className="mb-4"></div>
                  <label className="mb-1 label">Transaction Date<span class="mandatory">*</span></label>
                  <div>
                    <SBDatePicker className="w-75" value={transactionData.TransDate ? moment(transactionData.TransDate) : null} onChange={udpateDate} />
                  </div>
                </div>
                <div className="col-md-4">
                                  <div> <Link className="noUnderLine" onClick={handleClick}>USD</Link></div>
                  <label className="mb-1 label">Amount<span class="mandatory">*</span></label>
                  <div className="d-flex gap-2">
                    <SBACurrencyInput
                      className="form-control w-75"
                      decimalsLimit={2}
                      value={(transactionData?.TransAmount).toFixed(2)}
                      onBlur={(e) => { udpateTransAmmount(e) }}
                    />
                   
                  </div>
                </div>
             
                <div className="col-md-4">
                                  <div> <Link className="noUnderLine" onClick={handleClick}>{portfolio?.CurrencyCode}</Link><span style={{marginLeft:'8px'}}>({currencyFormatter(transactionData.ExchangeRate,2)})</span></div>
                  <label className="mb-1 label">Local Amount<span class="mandatory">*</span></label>
                  <div className="d-flex gap-2">
                    <SBACurrencyInput
                      className="form-control w-75"
                      decimalsLimit={2}
                      value={(transactionData?.ExchangeRate * transactionData?.TransAmount).toFixed(2)}
                      disabled
                    />
                   
                  </div>
                </div>
              </div>
              <div className="row mb-4">
              <div className="col-md-4">
                <label className="mb-1 label">  <input type="checkbox" checked={transactionData.IsCommitmentRelease} onChange={(e) => { setTransactionData(value => ({ ...value, IsCommitmentRelease: e.target.checked })) }} /> Release Commitment</label>
                <div>
                </div>
              </div>
              </div>
              <div className="row mb-4">
              <div className="col-md-9">
                <label className="mb-1 label">Description</label>
                <div>
                  <textarea className="form-control w-280" type="text" value={transactionData?.TransDescription} onChange={(e) => { setTransactionData(value => ({ ...value, TransDescription: e.target.value })) }} />
                </div>
               
              </div>
              
             </div>
             <div className="row mb-4">
              <div className="col-md-9">
             <div
                className="m-3 d-flex justify-content-end mt-2"
              >
                <button className="s-sm-btn" onClick={() => { navigateBack() }}>
                  Cancel
                </button>
                                      {transactionId !== 0 ? (
                                          <button className="ms-2 p-sm-btn" disabled={!transactionEditAccess || transactionData.IsLocked} onClick={() => { saveCommitment() }}>
                                              Save
                                          </button>
                                      ): (
                                              <button className="ms-2 p-sm-btn" disabled={false} onClick={() => { saveCommitment() }}>
                                                  Save
                                              </button>
                                          )}

                                      
              </div>
            </div></div>
            </div>


          </div>


        </div>
      </div>
      <ExchangeRateModal showModal={showModal} value={transactionData?.ExchangeRate} closeModal={()=>{setShowModal(false)}} onBlur={(e)=>exchangeRateChange(e)}></ExchangeRateModal>
      <ToastContainer></ToastContainer>
    </>
  );
};

const getPortfolioListByTerms = async (term) => {
  try {
    const response = await sbaAxios({ url: getPortfolioListAPI + '?searchText=' + term });
    return response;
  }
  catch (e) {
    return [];
  }
};
const getPortfolioExistingAssets = async (portfolioId) => {
  try {
    const response = await sbaAxios({ url: getPortfolioExistingAsset + portfolioId });
    return response;
  }
  catch (e) {
    return [];
  };
};
const getPortfolioDetailsByID = async (portfolioId) => {
  try {
    const response = await sbaAxios({ url: getPortfolioDetailAPI + portfolioId });
    return response;
  }
  catch (e) {
    console.log(e, 'Error Fetching the portfolio details')
    return {};
  };
};
const getAssetByID = async (AssetID) => {
  try {
    const response = await sbaAxios({ url: assetDetailsUrl + AssetID });
    return response;
  }
  catch (e) {
    console.log(e, 'Error Fetching the Asset details')
    return {};
  };
};
const getAssetListByTerms = async (term) => {
  try {
    const response = await sbaAxios({ url: getAssetListByTermApi + term });
    return response;
  }
  catch (e) {
    return [];
  }
};


var date = new Date();
var TransactionDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);
const plainCommitment = {
  "TransId": 0,
  "TransTypeId": 23,
  "TransTypeName": "Commitment",
  "PortfolioId": 0,
  "PortfolioName": "",
  "AssetId": 0,
  "AssetName": "",
  "ShareclassId": 0,
  "ShareClassName": "",
  "AssetLotId": 0,
  "AssetLotName": "",
  "TradeStatusId": 2,
  "TradeStatusName": "Executed",
  "TransDate": TransactionDate,
  "TransAmount": 0,
  "CurrencyId": 0,
  "CurrencyCode": "",
  "ExchangeRateId": 0,
  "ExchangeRate": 1,
  "IsFullRedemption": false,
  "IsInsurance": false,
  "IsFee": false,
  "IsCommitmentRelease": false,
  "TransDescription": "",
  "ModifiedById": 0,
  "ModifiedByName": "",
  "ChildDetails": []
}
